import React from "react";

export const LazyComponent = React.lazy(() => import('../../pages/admin/stats'))